import { Grid } from '@mui/material';
import { Control, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateGuiVersionType } from 'types/compobotGuiVersion.type';
import FormField from '../FormField';

interface CustomPageParametersSectionProps {
  control: Control<CreateGuiVersionType>;
  errors: FieldErrors<CreateGuiVersionType>;
}

export default function CustomPageParametersSection({
  control,
  errors,
}: CustomPageParametersSectionProps) {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12}>
        {/* <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          {t('createGuiVersionPage.customPageParameters')}
        </Typography> */}
      </Grid>
      <Grid item xs={12}>
        <FormField
          name="backgroundImage"
          control={control}
          errors={errors}
          label={t('createGuiVersionPage.backgroundImage')}
        />
      </Grid>
    </>
  );
}
